export function isConfigAllowed(state, configName) {
  if (
    !state.configs ||
    !state.configs[configName] ||
    !state.configs[configName].data.allowed
  ) {
    return false;
  }

  return state.configs[configName].data.allowed;
}
